function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// I'm terribly sorry about this in particular
function $9ea84de037b1f566$var$dirtyColumnResize(columns, selectors) {
    selectors.forEach((selector)=>{
        const heights = [
            ...columns.querySelectorAll(selector)
        ].map((node)=>{
            const { height: height } = node.getBoundingClientRect();
            return height;
        });
        const maxHeight = Math.max(...heights);
        columns.querySelectorAll(selector).forEach((node)=>{
            node.style.height = `${maxHeight}px`;
        });
    });
}
function $9ea84de037b1f566$var$enjoyYourLayoutShift() {
    if (window.innerWidth < 782) return;
    document.querySelectorAll("main .wp-block-columns").forEach((columns)=>{
        const selectors = [
            ".wp-block-heading",
            "p"
        ];
        $9ea84de037b1f566$var$dirtyColumnResize(columns, selectors);
    });
}
function $9ea84de037b1f566$export$2e2bcd8739ae039() {
    window.addEventListener("load", $9ea84de037b1f566$var$enjoyYourLayoutShift);
    window.addEventListener("resize", $9ea84de037b1f566$var$enjoyYourLayoutShift);
}


var $edee4909e292aad1$exports = {};
(function(global, factory) {
    $edee4909e292aad1$exports = factory();
})($edee4909e292aad1$exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});


const $8faf05394a70d6cc$var$DOMAIN = ".be-my-media.com";
/**
 * CF7: Add cookies to Forms fields
 * https://github.com/js-cookie/js-cookie
 */ // 1 - Generic helper functions
/**
 * @returns {boolean} - Whether this is a local setup
 */ function $8faf05394a70d6cc$var$isPre0() {
    return window.location.host.indexOf("pre0.be-my-media.com") === 0;
}
/**
 *
 * @param {string} utmVar - UTM parameter value
 * @param {boolean} url - If this is an URL
 * @returns {string} - The clean value
 */ function $8faf05394a70d6cc$var$cleanParam(utmVar, url) {
    let cleanVar = utmVar.trim().replace("|", "-").replace(/;/g, "").replace(/'/g, "").replace(/"/g, "").replace(/,/g, "").replace(/(<([^>]+)>)/gi, "").replace(/</g, "").replace(/>/g, "").replace(/\$/g, "").replace(/@/g, "");
    if (url !== true) cleanVar = cleanVar.replace(/\?/g, "").replace(/&/g, "").replace(/=/g, "").replace(/#/g, "").replace(/\//g, "").replace(/:/g, "");
    return cleanVar;
}
/**
 *
 * @returns {CookieAttributes} - Cookie Attributes
 */ function $8faf05394a70d6cc$var$getCookieArgs() {
    return {
        path: "/",
        domain: $8faf05394a70d6cc$var$DOMAIN,
        secure: !$8faf05394a70d6cc$var$isPre0(),
        sameSite: "strict"
    };
}
/**
 *
 * @param {string} cookieName - Names of the cookie
 * @returns {boolean} - Whether the cookie is set
 */ function $8faf05394a70d6cc$var$isCookieSet(cookieName) {
    return typeof (0, (/*@__PURE__*/$parcel$interopDefault($edee4909e292aad1$exports))).get(cookieName) !== "undefined" && (0, (/*@__PURE__*/$parcel$interopDefault($edee4909e292aad1$exports))).get(cookieName) !== "";
}
/**
 *
 * @param {string[]} cookiesNames - Names of the cookies
 * @returns {boolean} - Whether cookies are set
 */ function $8faf05394a70d6cc$var$areCookiesSet(cookiesNames) {
    let cookiesAreSet = false;
    cookiesNames.forEach((cookieName)=>{
        if ($8faf05394a70d6cc$var$isCookieSet(cookieName)) cookiesAreSet = true;
    });
    return cookiesAreSet;
}
// 2 - UTM Cookies
/**
 *
 * @param {string} theParameterName - Name of the GET parameter to find
 * @returns {false | string} - Value of the parameter on success
 */ function $8faf05394a70d6cc$var$findTheGetParameter(theParameterName) {
    let pmresult = false;
    let pmtmp = [];
    const pmitems = window.location.search.substr(1).split("&");
    pmitems.forEach((pm)=>{
        pmtmp = pm.split("=");
        const [paramName, paramValue] = pmtmp;
        if (paramName === theParameterName) pmresult = paramValue;
    });
    return pmresult;
}
/**
 * @returns {string[]} - Names of UTM parameters
 */ function $8faf05394a70d6cc$var$getUtmNamesArray() {
    return [
        "utm_medium",
        "utm_source",
        "utm_campaign",
        "utm_content",
        "utm_term"
    ];
}
/**
 * @returns {string[]} - Landing page cookies names
 */ function $8faf05394a70d6cc$var$getUtmCookieNames() {
    return $8faf05394a70d6cc$var$getUtmNamesArray().map((utm)=>`bemymedia_utmcookie_${utm}`);
}
/**
 * @returns {boolean} - Whether UTM cookies are set
 */ function $8faf05394a70d6cc$var$areUtmCookiesSet() {
    const utmCookies = $8faf05394a70d6cc$var$getUtmCookieNames();
    return $8faf05394a70d6cc$var$areCookiesSet(utmCookies);
}
/**
 * @returns {boolean} - Success
 */ function $8faf05394a70d6cc$var$setUtmCookies() {
    if ($8faf05394a70d6cc$var$areUtmCookiesSet()) return false;
    const utmParams = $8faf05394a70d6cc$var$getUtmNamesArray().map((utm)=>[
            `bemymedia_utmcookie_${utm}`,
            $8faf05394a70d6cc$var$findTheGetParameter(utm)
        ]);
    const args = $8faf05394a70d6cc$var$getCookieArgs();
    utmParams.forEach(([cookieName, utmValue])=>{
        if (utmValue && cookieName) (0, (/*@__PURE__*/$parcel$interopDefault($edee4909e292aad1$exports))).set(cookieName, $8faf05394a70d6cc$var$cleanParam(`${utmValue}`, false), args);
    });
    return true;
}
// 3 - Landing page Cookies
/**
 * @returns {string[]} - Landing page cookies names
 */ function $8faf05394a70d6cc$var$getLandingCookieNames() {
    return [
        "bemymedia_cookie_landing_page",
        "bemymedia_cookie_landing_cat"
    ];
}
/**
 * @returns {boolean} - Whether landing page cookies are set
 */ function $8faf05394a70d6cc$var$areLandingCookiesSet() {
    const utmCookies = $8faf05394a70d6cc$var$getLandingCookieNames();
    return $8faf05394a70d6cc$var$areCookiesSet(utmCookies);
}
/**
 * @returns {boolean} - Success
 */ function $8faf05394a70d6cc$var$setLandingCookies() {
    if ($8faf05394a70d6cc$var$areLandingCookiesSet()) return false;
    const currentUrl = `${window.location.origin}${window.location.pathname}`;
    const landingCat = "Site be. my media";
    const args = $8faf05394a70d6cc$var$getCookieArgs();
    (0, (/*@__PURE__*/$parcel$interopDefault($edee4909e292aad1$exports))).set("bemymedia_cookie_landing_page", $8faf05394a70d6cc$var$cleanParam(currentUrl, true), args);
    (0, (/*@__PURE__*/$parcel$interopDefault($edee4909e292aad1$exports))).set("bemymedia_cookie_landing_cat", $8faf05394a70d6cc$var$cleanParam(landingCat, false), args);
    return true;
}
/**
 * Remove Google Analytics URL parameters for cross-domain tracking
 *
 * @param {number} i - Recursion level
 * @returns {boolean} - Success
 */ function $8faf05394a70d6cc$var$cleanUrlFromGaParams(i) {
    if (window.location.search.includes("_ga=") || window.location.search.includes("_gl=")) {
        if (i > 20 // recursion capped at 20
         || typeof window.ga !== "undefined" && typeof window.ga.getAll === "function" && window.ga.getAll().length && typeof window.ga.getAll()[0].get("clientId") === "string") {
            // push canonical href into history
            const canonicalTag = document.querySelector("link[rel='canonical']");
            if (canonicalTag && Object.prototype.hasOwnProperty.call(canonicalTag, "href")) {
                window.history.replaceState({}, "", canonicalTag.href);
                return true;
            }
            // fallback (no canonical)
            window.history.replaceState({}, "", window.location.pathname);
            return true;
        }
        setTimeout($8faf05394a70d6cc$var$cleanUrlFromGaParams, 500, i + 1);
    }
    return true;
}
// 4 - Main
window.addEventListener("load", ()=>{
    // Set cookies for UTMs and landing page
    $8faf05394a70d6cc$var$setUtmCookies();
    $8faf05394a70d6cc$var$setLandingCookies();
    // Remove GA params to show a clean URL
    $8faf05394a70d6cc$var$cleanUrlFromGaParams(0);
});


(0, $9ea84de037b1f566$export$2e2bcd8739ae039)();


//# sourceMappingURL=index.77221e63.js.map
